var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"cluster-nodes-line-graph alert alert-info\">\n<h4>{{cNLGraphCtrl.header || cNLGraphCtrl.key}}</h4>\n<div class=\"outer-container\">\n<div class=\"chart\"></div>\n</div>\n</div>";
var id1="components/cluster-nodes-line-graph/cluster-nodes-line-graph.template.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./ui/src/components/cluster-nodes-line-graph/cluster-nodes-line-graph.template.html
// module id = 954
// module chunks = 0